import {
	BigNum,
	PRICE_PRECISION_EXP,
	QUOTE_PRECISION_EXP,
	User,
	PositionDirection,
} from '@drift-labs/sdk';
import { COMMON_UI_UTILS } from '@drift/common';

/**
 * Checks if the max leverage flag is correctly set by checking max usdc trade size is within 1% of the passed base size
 */
export const checkMaxLeverageFlagUsage = (
	isMaxLeverageSelected: boolean,
	marketIndex: number,
	inputBaseSize: BigNum,
	oraclePrice: BigNum,
	user: User,
	direction: PositionDirection,
	positionMaxLeverage: number,
	highLeverageSpotsOpen?: number
) => {
	if (!isMaxLeverageSelected) return false;

	const marginRatio =
		COMMON_UI_UTILS.convertLeverageToMarginRatio(positionMaxLeverage);

	const tradeQuoteSize = inputBaseSize
		.shiftTo(PRICE_PRECISION_EXP)
		.mul(oraclePrice) // multiply by oracle price to get quote size because margin system is based on oracle price and not trade price
		.shiftTo(QUOTE_PRECISION_EXP);

	const userMaxTradeSizeUsdc = BigNum.from(
		user.getMaxTradeSizeUSDCForPerp(
			marketIndex,
			direction,
			undefined,
			highLeverageSpotsOpen !== undefined && highLeverageSpotsOpen > 0,
			marginRatio
		).tradeSize,
		QUOTE_PRECISION_EXP
	);
	const onePercent = userMaxTradeSizeUsdc.scale(1, 100);

	const isCorrectMaxLeverageFlagUsage = userMaxTradeSizeUsdc
		.sub(tradeQuoteSize)
		.abs()
		.lt(onePercent);

	return isCorrectMaxLeverageFlagUsage;
};
